module.exports = __webpack_public_path__ + "static/img/redPack.897f23c.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/img/redPack.png
// module id = nyfg
// module chunks = 87